import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое адаптация сотрудников?',
    a: 'Адаптация сотрудников — это системный процесс ввода нового работника в должность, знакомства с корпоративной культурой, правилами, стандартами и задачами компании. Цель адаптации — чтобы сотрудник быстро вышел на требуемый уровень эффективности и стал полноценным членом команды.',
  },
  {
    q: 'Что такое онбординг (Onboarding)?',
    a: 'Онбординг — современный термин для программы адаптации персонала, который подразумевает комплексную систему ввода сотрудника в компанию. Включает welcome-программу, обучение, наставничество, чек-листы, базу знаний и регулярную обратную связь на всех этапах.',
  },
  {
    q: 'Чем адаптация отличается от испытательного срока?',
    a: 'Испытательный срок — это юридический статус сотрудника (обычно до 3 месяцев), в течение которого работодатель оценивает сотрудника, а сотрудник — компанию. Адаптация — это HR-процесс, который может длиться от 2 недель до 6+ месяцев и направлен на интеграцию сотрудника в компанию, его обучение и профессиональное развитие.',
  },
  {
    q: 'Сколько длится адаптация сотрудника?',
    a: 'Базовая адаптация — 2-4 недели (знакомство с компанией, процессами, командой). Полная интеграция — 3-6 месяцев (выход на KPI, усвоение корпоративной культуры). Для руководителей и сложных должностей адаптация может длиться до года. Длительность зависит от должности, сложности продукта и корпоративной культуры.',
  },
  {
    q: 'Кто отвечает за адаптацию новых сотрудников?',
    a: 'HR-специалист, непосредственный руководитель и наставник работают в связке. HR координирует процесс и готовит материалы, руководитель ставит задачи и даёт обратную связь, наставник обучает и помогает освоиться в ежедневной работе. Ответственность за результат адаптации лежит на руководителе.',
  },
  {
    q: 'Нужен ли наставник для адаптации?',
    a: 'Да, наставник критически важен для успешной адаптации. Он помогает новичку освоить рабочие процессы, отвечает на вопросы, делится опытом и поддерживает в первые недели. Наставник сокращает время выхода на KPI в 1,5-2 раза и снижает тревожность новичка. Без наставника система адаптации не работает.',
  },
  {
    q: 'Что входит в программу адаптации сотрудников?',
    a: 'Welcome-программа (знакомство с компанией и командой), наставничество, чек-листы на каждую неделю, план обучения на испытательный срок, доступ к базе знаний и регламентам, книга продаж (для продавцов), регулярные встречи с руководителем, промежуточная и финальная оценка.',
  },
  {
    q: 'Какие документы необходимы для адаптации?',
    a: 'Welcome-план (расписанный по дням), чек-лист первой недели и первого месяца, план обучения на испытательный срок, форма промежуточной и финальной оценки, регламент работы наставника, анкета обратной связи от новичка. Эти документы создают единый стандарт онбординга для всей компании.',
  },
  {
    q: 'Как оценить эффективность адаптации?',
    a: 'Эффективность измеряется по шести показателям: время выхода на KPI, текучесть в первые 3-6 месяцев, уровень вовлечённости, оценка руководителя на контрольных точках, самооценка сотрудника и итоговая эффективность (KPI + компетенции + фидбэк команды).',
  },
  {
    q: 'Какие ошибки совершают компании при адаптации?',
    a: 'Главные ошибки: бросить новичка «разбирайся сам», отсутствие наставника, перегруз информацией в первый день, исчезновение руководителя после найма, отсутствие системы оценки и обратной связи, отсутствие единых стандартов адаптации для всей компании.',
  },
  {
    q: 'Как адаптировать удалённых сотрудников?',
    a: 'Для удалённых сотрудников нужен онлайн-онбординг: видеозвонки-знакомства с командой, электронные чек-листы, доступ к базе знаний и корпоративным системам, регулярные онлайн-встречи с руководителем и наставником, виртуальные welcome-мероприятия. Принципы те же, что в офисе — меняются только инструменты.',
  },
  {
    q: 'Можно ли внедрить систему адаптации самостоятельно?',
    a: 'Можно, но процесс займёт значительно больше времени и сопряжён с типичными ошибками. Профессиональное внедрение с экспертом ускоряет результат в 2-3 раза за счёт готовых методик, проверенных чек-листов, опыта работы с десятками компаний и возможности избежать дорогостоящих ошибок.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Часто задаваемые вопросы об адаптации сотрудников
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы об онбординге, наставничестве и системе адаптации персонала
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}